// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_v5-0";
export var checkoutRateBadgeLink = "_v5-1";